require('./webp-check');
require('./modals');
require('./popup');

window.stripeButton = params => {
    return {
        submitting: false,
        showModal: false,
        error: null,
        submit() {
            this.error = null;

            if (!this.$refs.tc_checkbox.checkValidity()) {
                this.$refs.form.reportValidity();
                return;
            }

            this.submitting = true;

            grecaptcha.ready(() => {
                grecaptcha
                    .execute(process.env.MIX_RECAPTCHA_SITE_KEY, {
                        action: 'subscribe',
                    })
                    .then(token => {
                        fetch('/stripe/session', {
                            method: 'POST',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'X-CSRF-Token': params.csrf_token,
                            },
                            body: JSON.stringify({
                                token,
                                price_id: params.price_id,
                                type: params.type,
                                success_url:
                                    params.success_url || 'payment/success',
                                cancel_url:
                                    params.cancel_url ||
                                    window.location.pathname,
                            }),
                        })
                            .then(async res => {
                                if (!res.ok) {
                                    const json = await res.json();
                                    throw new Error(json.message);
                                }

                                return res.json();
                            })
                            .then(res => {
                                return stripe.redirectToCheckout({
                                    sessionId: res.session_id,
                                });
                            })
                            .catch(e => {
                                this.submitting = false;
                                this.error = e.message;
                            });
                    });
            });
        },
    };
};

window.contactForm = params => {
    return {
        submitting: false,
        submit(e) {
            e.preventDefault();

            this.submitting = true;

            grecaptcha.ready(() => {
                grecaptcha
                    .execute(process.env.MIX_RECAPTCHA_SITE_KEY, {
                        action: 'verify_contact',
                    })
                    .then(token => {
                        fetch('/verify-contact-form', {
                            method: 'POST',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'X-CSRF-Token': params.csrf_token,
                            },
                            body: JSON.stringify({
                                token,
                                price_id: params.price_id,
                                type: params.type,
                                success_url:
                                    params.success_url || 'payment/success',
                                cancel_url:
                                    params.cancel_url ||
                                    window.location.pathname,
                            }),
                        })
                            .then(async res => {
                                if (!res.ok) {
                                    const json = await res.json();
                                    throw new Error(json.message);
                                }

                                return res.json();
                            })
                            .then(res => {
                                this.$refs.form.submit();
                            })
                            .catch(e => {
                                this.submitting = false;
                            });
                    });
            });
        },
    };
};

window.gearRedirect = () => ({
    countdown: 15,
    showCountdown: true,
    init() {
        const instructions = document.querySelector('.bard-text strong em');

        instructions.classList.add('text-3xl');

        const highlightClasses = 'bg-yellow-300 inline-block pl-2 pr-3';

        instructions.innerHTML = instructions.innerHTML
            .replace(
                'check your email',
                `<span class="${highlightClasses}">check your email</span>`,
            )
            .replace(
                'fill out your questionnaire',
                `<span class="${highlightClasses}">fill out your questionnaire</span>`,
            );

        setTimeout(() => {
            this.tickDown();
        }, 1000);
    },
    tickDown() {
        this.countdown--;

        if (this.countdown === 0) {
            window.location.href = 'https://mflhgear.com/';
        } else {
            setTimeout(() => {
                this.tickDown();
            }, 1000);
        }
    },
});

if (document.querySelector('.date-picker')) {
    const initDatePicker = () => {
        document.querySelectorAll('.date-picker').forEach(el => {
            el.type = 'text';

            new Pikaday({
                field: el,
                theme: 'dark-theme',
                format: 'YYYY-MM-DD',
                toString(date, format) {
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();
                    return `${month}/${day}/${year}`;
                },
            });
        });
    };

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/pikaday/pikaday.js';
    script.onload = initDatePicker;

    document.body.appendChild(script);

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = 'https://cdn.jsdelivr.net/npm/pikaday/css/pikaday.css';

    document.head.appendChild(link);
}
